__turbopack_context__.v({
  "appear-slide-left": "StepContent-module-scss-module__OXP5WW__appear-slide-left",
  "bounceTwice": "StepContent-module-scss-module__OXP5WW__bounceTwice",
  "content": "StepContent-module-scss-module__OXP5WW__content",
  "content--animate": "StepContent-module-scss-module__OXP5WW__content--animate",
  "fade-in-bottom": "StepContent-module-scss-module__OXP5WW__fade-in-bottom",
  "fade-in-left": "StepContent-module-scss-module__OXP5WW__fade-in-left",
  "fade-in-right": "StepContent-module-scss-module__OXP5WW__fade-in-right",
  "fadeIn": "StepContent-module-scss-module__OXP5WW__fadeIn",
  "image": "StepContent-module-scss-module__OXP5WW__image",
  "loader": "StepContent-module-scss-module__OXP5WW__loader",
  "puff-in-center": "StepContent-module-scss-module__OXP5WW__puff-in-center",
  "puff-in-left": "StepContent-module-scss-module__OXP5WW__puff-in-left",
  "pulse": "StepContent-module-scss-module__OXP5WW__pulse",
  "pulse-contact": "StepContent-module-scss-module__OXP5WW__pulse-contact",
  "shake-bottom": "StepContent-module-scss-module__OXP5WW__shake-bottom",
  "slide-again": "StepContent-module-scss-module__OXP5WW__slide-again",
  "slide-in-right": "StepContent-module-scss-module__OXP5WW__slide-in-right",
  "stepContent-entrance": "StepContent-module-scss-module__OXP5WW__stepContent-entrance",
  "title": "StepContent-module-scss-module__OXP5WW__title",
});
